module.exports = __webpack_public_path__ + "0b51ceb1642e3cbbf60ea8a012100eb2.pdf";